import { render } from "./ListagemDeSociosCadastro.vue?vue&type=template&id=30a60656&scoped=true"
import script from "./ListagemDeSociosCadastro.vue?vue&type=script&lang=js"
export * from "./ListagemDeSociosCadastro.vue?vue&type=script&lang=js"

import "./ListagemDeSociosCadastro.vue?vue&type=style&index=0&id=30a60656&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a60656"],['__file',"src/views/Legalize/CadastroDeProcessos/Components/ListagemDeSociosCadastro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30a60656"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30a60656', __exports__)) {
    console.log('reload')
    api.reload('30a60656', __exports__)
  }
  
  module.hot.accept("./ListagemDeSociosCadastro.vue?vue&type=template&id=30a60656&scoped=true", () => {
    console.log('re-render')
    api.rerender('30a60656', render)
  })

}


export default __exports__